// Note: some of these descriptions should be removed
// to reflect the new changes in the selections editor
// as they are no longer supported
export const selectionDescriptions = {
  question: {
    default: 'Selected value will be updated by question'
  },
  stackedbars: {
    default: 'Each pair of values becomes a row of two comparison bars',
    groups: 'Each group of 2 selections becomes a row of two comparison bars'
  },
  barchart: {
    default: 'Each pair of selections becomes a column',
    groups: 'Each group of selections becomes a group of bars'
  },
  stackedbarchart: {
    default: 'Each pair of selections becomes a stacked column',
    stacked: 'Creates a stacked column from each group of selections',
    categories: 'Each selection becomes a layer in each stack'
  },
  linechart: {
    default: 'Each pair of selections becomes a point on a line',
    multiLine: 'Each group of selections become points on a new line'
  },
  list: {
    default: 'Each selected value becomes a row'
  },
  overview: {
    default: 'Each selection becomes an overview cell'
  },
  table: {
    default: 'A single selection becomes a full table containing all headers and data',
    rows: 'Each selection becomes a row of headers and/or table data',
    columns: 'Each selection becomes a column including any header and data'
  },
  bubble: {
    default: 'Each group of selections becomes individual bubbles',
    categories: 'Each group of selections becomes a category of bubbles'
  },
  scatter: {
    default: 'Each group of selections becomes individual points',
    categories: 'Each group of selections becomes a category of points'
  },
  piedoughnut: {
    default: 'Each selection becomes segment(s) of a single ring',
    rings: 'Each group of selections becomes the segments of multiple rings'
  },
  treemap: {
    default: 'Each group of selections becomes a block of values',
    flat: 'Each selection creates a list of single-level blocks'
  },
  receipt: {
    default: 'Each selected value becomes a row'
  },
  gauge: {
    default: 'A single percentage selection becomes a gauge'
  },
  radar: {
    default: 'Each selected value becomes a point on the radar chart'
  }
};
export const labelsSelectionsSupported = {
  question: {},
  table: {
    default: true
  },
  overview: {},
  piedoughnut: {
    rings: true
  },
  stackedbars: {},
  list: {},
  treemap: {},
  barchart: {
    groups: true
  },
  stackedbarchart: {
    stacked: true
  },
  linechart: {
    multiLine: true
  },
  bubble: {
    categories: true
  },
  scatter: {
    categories: true
  },
  receipt: {
    default: true
  },
  gauge: {
    default: true
  },
  radar: {
    default: true
  }
};
export const legendsSelectionsSupported = {
  question: {},
  table: {},
  overview: {},
  piedoughnut: {},
  stackedbars: {},
  list: {},
  treemap: {},
  barchart: {
    groups: true
  },
  stackedbarchart: {
    stacked: true
  },
  linechart: {
    multiLine: true
  },
  bubble: {
    categories: true
  },
  scatter: {
    categories: true
  },
  receipt: {},
  gauge: {},
  radar: {
    default: true
  }
}; // Temporary overrides for specific configurations

export const configOverrides = {
  question: {},
  table: {
    selectionsLabeled: false,
    selectionsStrategy: 'default'
  },
  overview: {},
  piedoughnut: {
    selectionsLabeled: false,
    selectionsStrategy: 'rings'
  },
  stackedbars: {},
  list: {},
  treemap: {},
  bubble: {
    selectionsLabeled: false,
    selectionsStrategy: 'categories'
  },
  barchart: {
    selectionsLabeled: false,
    selectionsStrategy: 'groups'
  },
  stackedbarchart: {
    selectionsLabeled: false,
    selectionsStrategy: 'stacked'
  },
  linechart: {
    selectionsLabeled: false,
    selectionsStrategy: 'multiLine'
  },
  scatter: {
    selectionsLabeled: false,
    selectionsStrategy: 'categories'
  },
  receipt: {
    selectionsLabeled: false,
    selectionsStrategy: 'default'
  },
  gauge: {
    selectionsLabeled: false,
    selectionsStrategy: 'default'
  },
  radar: {
    selectionsLabeled: false,
    selectionsStrategy: 'default'
  }
};
export const multiCollectionSelections = {
  question: [],
  stackedbars: ['groups'],
  list: [],
  table: [],
  overview: [],
  barchart: ['groups'],
  stackedbarchart: ['stacked'],
  linechart: ['multiLine'],
  bubble: ['categories'],
  scatter: ['categories'],
  piedoughnut: ['rings'],
  treemap: ['default'],
  receipt: [],
  gauge: [],
  radar: ['default']
};
export const multiCollectionMaximums = {
  // Example
  // table: { rows: 2 },
  gauge: {
    default: 1
  },
  receipt: {
    default: 1
  },
  table: {
    default: 1
  }
};
export const maxSelections = {
  question: {
    default: 1
  },
  piedoughnut: {},
  stackedbars: {// TODO: ensure that each collection is limited to 2 selections
    // groups: 2
  },
  list: {},
  table: {
    default: 1
  },
  overview: {
    default: 4
  },
  treemap: {},
  bubble: {},
  barchart: {},
  stackedbarchart: {},
  linechart: {},
  scatter: {},
  receipt: {},
  gauge: {
    default: 1
  },
  radar: {}
}; // Keys for components should be lower case

export const selectionLimits = {
  list: {
    default: {
      size: Infinity
    },
    defaultlabeled: {
      size: Infinity
    }
  },
  overview: {
    default: {
      size: 3
    }
  },
  stackedbars: {
    default: {
      size: Infinity
    },
    defaultlabeled: {
      size: Infinity
    },
    groups: {
      size: 1
    },
    groupslabeled: {
      size: 2
    }
  },
  // NOTE: limiting question 2 or fewers cells is critical
  //       to downstream logic that inserts these values into the
  //       spreadsheet when results are generated
  question: {
    default: {
      size: 1
    },
    defaultlabeled: {
      size: 2
    }
  },
  receipt: {
    default: {
      size: Infinity
    },
    defaultlabeled: {
      size: Infinity
    }
  },
  bubble: {
    default: {
      size: Infinity
    },
    defaultlabeled: {
      size: Infinity
    },
    categories: {
      size: Infinity
    },
    categorieslabeled: {
      size: Infinity
    }
  },
  scatter: {
    default: {
      size: Infinity
    },
    defaultlabeled: {
      size: Infinity
    },
    categories: {
      size: Infinity
    },
    categorieslabeled: {
      size: Infinity
    }
  },
  piedoughnut: {
    default: {},
    defaultlabeled: {},
    rings: {}
  },
  table: {
    rows: {
      size: Infinity
    },
    columns: {
      size: Infinity
    }
  },
  gauge: {
    default: {
      size: 1
    }
  },
  treemap: {},
  // use defaults
  barchart: {},
  // use defaults
  stackedbarchart: {},
  // use defaults
  linechart: {},
  // use defaults
  radar: {} // use defaults

};
export const selectionTextOverrides = {
  question: {},
  stackedbars: {},
  list: {},
  table: {
    default: {
      collectionGroupTitle: 'Body'
    }
  },
  overview: {},
  barchart: {},
  stackedbarchart: {
    stacked: {
      collectionGroupTitle: 'Segment',
      addCollectionButton: 'Add Segment',
      deleteCollectionButton: 'Delete Segment'
    }
  },
  linechart: {
    multiLine: {
      collectionGroupTitle: 'Line',
      addCollectionButton: 'Add Line',
      deleteCollectionButton: 'Delete Line'
    }
  },
  bubble: {
    categories: {
      collectionGroupTitle: 'Category',
      addCollectionButton: 'Add Category',
      deleteCollectionButton: 'Delete Category'
    }
  },
  scatter: {
    categories: {
      collectionGroupTitle: 'Category',
      addCollectionButton: 'Add Category',
      deleteCollectionButton: 'Delete Category'
    }
  },
  piedoughnut: {
    rings: {
      collectionGroupTitle: 'Ring',
      addCollectionButton: 'Add Ring',
      deleteCollectionButton: 'Delete Ring'
    }
  },
  treemap: {},
  receipt: {},
  gauge: {
    default: {
      collectionGroupTitle: 'Value'
    }
  },
  radar: {
    default: {
      collectionGroupTitle: 'Layer',
      addCollectionButton: 'Add Layer',
      deleteCollectionButton: 'Delete Layer'
    }
  }
};
export const selectionGuides = {
  question: {},
  table: {
    default: {
      labelSelection: '/img/guides/sections/tables/label-selection.webp',
      valueSelection: '/img/guides/sections/tables/value-selection.webp'
    }
  },
  overview: {},
  piedoughnut: {
    rings: {
      labelSelection: '/img/guides/sections/pieDoughnutCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/pieDoughnutCharts/value-selection.gif'
    }
  },
  stackedbars: {},
  list: {},
  treemap: {},
  bubble: {
    categories: {
      labelSelection: '/img/guides/sections/bubbleCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/bubbleCharts/value-selection.gif'
    }
  },
  barchart: {
    groups: {
      labelSelection: '/img/guides/sections/barCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/barCharts/value-selection.gif'
    }
  },
  stackedbarchart: {
    stacked: {
      labelSelection: '/img/guides/sections/stackedBarCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/stackedBarCharts/value-selection.gif'
    }
  },
  linechart: {
    multiLine: {
      labelSelection: '/img/guides/sections/lineCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/lineCharts/value-selection.gif'
    }
  },
  scatter: {
    categories: {
      labelSelection: '/img/guides/sections/scatterCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/scatterCharts/value-selection.gif'
    }
  },
  receipt: {
    default: {
      labelSelection: '/img/guides/sections/receipts/label-selection.webp',
      valueSelection: '/img/guides/sections/receipts/value-selection.webp'
    }
  },
  gauge: {
    default: {
      labelSelection: '/img/guides/sections/gaugeCharts/label-selection.webp',
      valueSelection: '/img/guides/sections/gaugeCharts/value-selection.webp'
    }
  },
  radar: {
    default: {
      labelSelection: '/img/guides/sections/radarCharts/label-selection.gif',
      valueSelection: '/img/guides/sections/radarCharts/value-selection.gif'
    }
  }
};
export default {
  selectionDescriptions,
  multiCollectionSelections,
  maxSelections,
  multiCollectionMaximums,
  selectionLimits,
  selectionTextOverrides,
  selectionGuides
};